import { useMemo } from "react";
import { useSelector } from "react-redux";
import { dealAnchoredProgressSelector } from "@state/dealAnchoredProgress/dealAnchoredProgress.selectors";
import { investorSelector } from "@state/investor/investor.selectors";
import { buildDealAnchoredView, DealAnchoredView } from "./progress";

/** The loaded deal-anchored progress in the web's terms, or null before it arrives. */
export const useDealAnchoredView = (): DealAnchoredView | null => {
  const progress = useSelector(dealAnchoredProgressSelector);
  const investorCreatedAt = useSelector(investorSelector)?.created_at;

  return useMemo(
    () => buildDealAnchoredView({ progress, investorCreatedAt }),
    [progress, investorCreatedAt]
  );
};
